
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex';
import { rateClient } from '@/apis';
import { useRouterBack } from '@/composables';
import { defineComponent, toRefs } from 'vue';
import FiveStars from '@/components/FiveStars.vue';
import { mapScoreToText } from '@/utils/rating';
import { CardReactiveRating } from '@/components/listCard';
import { RatingHeadBar, LectureDetailInfo } from './components';
import { useLectureInfo, useLectureRatings } from './composables';

export default defineComponent({
  components: {
    RatingHeadBar,
    FiveStars,
    LectureDetailInfo,
    CardReactiveRating,
  },
  props: {
    /** 传入的搜索字串 */
    lectureId: { type: String, required: true },
  },
  setup(props) {
    const { lectureId } = toRefs(props);

    // 获取课程信息
    const { lectureInfo, loading } = useLectureInfo(lectureId);

    // 获取点评列表
    const { ratingList } = useLectureRatings(lectureId);

    return {
      /** 课程基本信息 */
      lectureInfo,
      /** 点评列表 */
      ratingList,
      /** 正在获取数据 */
      loading,
      /** 路由回退 */
      routerBack: useRouterBack(),
    };
  },
  methods: {
    isCurrentUser(creatorId: string) {
      const store = useStore();
      if (creatorId === store.state.user.id) {
        return true;
      }
      return false;
    },
    mapScoreToText,
    /** 点击关注按钮 */
    handleClickWatch() {
      // TODO: 接入 API
      this.lectureInfo.watched = !this.lectureInfo.watched;
    },
    /** 点击收藏按钮 */
    handleClickStar() {
      // TODO: 接入 API
      if (this.lectureInfo.starred) {
        this.lectureInfo.starred = false;
        this.lectureInfo.starCount -= 1;
      } else {
        this.lectureInfo.starred = true;
        this.lectureInfo.starCount += 1;
      }
    },
    /** 点击点评按钮 */
    handleEditRating() {
      this.$router.push(`/rating/lecture/${this.lectureId}/edit-rating`);
    },
    deleteShow() {
      Modal.confirm({
        title: '确认删除',
        okType: 'danger',
        okText: '确认',
        cancelText: '取消',
        content: '确定要删除点评吗？（不可恢复）',
        onOk: () => {
          rateClient.deleteRating({ lectureId: this.lectureId })
            .then((resp) => {
              this.$message.success('删除点评成功');
              this.ratingList = resp.data;
            });
        },
      });
    },
  },
});
